import { SVG, SVGProps } from './svg'

export function IconCaretDown(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M8 11a1 1 0 010-1h8v1l-4 4-4-4z" />
    </SVG>
  )
}
